import {Box, Flex, Text, useDisclosure} from '@chakra-ui/react';
import {IconBlock} from 'components/layouts/aside-layout';
import {colors} from 'components/providers';
import {DelayedTime} from 'components/shared/delivery-method/components';
import {useFormDate, useTranslation} from 'hooks';
import {FC, useEffect} from 'react';
import {IPreOrderData} from 'types';

import {BtnWithPlus} from './BtnWithPlus';

interface IProps {
  provider_is_open?: boolean;
  preOrder?: IPreOrderData;
  providerDeliveredTime?: string;
  restaurantClosed: boolean;
  accepts_preorders: boolean;
}

export const PreOrder: FC<IProps> = ({
  preOrder,
  provider_is_open,
  providerDeliveredTime,
  restaurantClosed,
  accepts_preorders,
}) => {
  const {distanceDay} = useFormDate('', 'dd.MM.yyyy', preOrder?.value); //preOrder?.value format'15-07-2022

  const {onOpen, isOpen, onClose} = useDisclosure();
  const {t} = useTranslation();

  useEffect(() => {
    //this condition may be provider_is_open === undefined && preOrder === undefined
    if (provider_is_open === false && !preOrder) {
      onOpen();
    }
  }, [provider_is_open, preOrder, onOpen]);

  const deliveryTimeTitle = distanceDay.isTomorrowDate
    ? `${t('TOMORROW_IN')} ${preOrder?.hour.display}`
    : distanceDay.isToday
    ? `${t('TODAY_IN')} ${preOrder?.hour.display}`
    : `${preOrder?.value} ${preOrder?.hour.display}`;

  const preorderTitle =
    preOrder && accepts_preorders ? (
      <Box>
        <Text fontWeight="500">{`${t('PREORDER')}`}</Text>
        <Text fontWeight="500">{deliveryTimeTitle}</Text>
      </Box>
    ) : restaurantClosed ? (
      `${t('PREORDER')}`
    ) : (
      `${t('DELIVERY')} ${providerDeliveredTime} ${t('MINUTES')}`
    );

  return (
    <>
      <IconBlock icon="/clock.svg">
        <Flex
          flexDirection={['column', 'row']}
          alignItems={['stretch', 'center']}
          justifyContent="space-between"
          alignSelf="center"
        >
          <Flex ml="10px" flexDirection="column">
            <Text as="span" fontSize={16} fontWeight={600} whiteSpace="pre-line">
              {preorderTitle}
            </Text>
            {accepts_preorders && (
              <Text as="div" fontSize="14px" fontWeight={500} color={colors.textGray}>
                {t('PRE_ORDER_SUB_TITLE')}
              </Text>
            )}
          </Flex>
          {accepts_preorders && <BtnWithPlus title={t('ADD_PRE_ORDER')} onClick={onOpen} />}
        </Flex>
      </IconBlock>

      {isOpen && <DelayedTime preOrder={preOrder} isOpen={isOpen} onClose={onClose} />}
    </>
  );
};
